import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Container, Label, LabelOptional, TextInputContainer, TextInput, LabelHint } from './TextArea.styled'

interface Props {
  value: string
  className?: string
  required?: boolean
  disabled?: boolean
  label?: string
  placeholder?: string
  hint?: string
  error?: boolean
  onChange?: (value: string, target: HTMLTextAreaElement) => void
  autoFocus?: boolean
  hideOptional?: boolean
}

export const TextArea = (props: Props): JSX.Element => {
  const {
    value,
    className,
    label,
    placeholder,
    hint,
    error,
    disabled,
    required,
    onChange,
    autoFocus,
    hideOptional = false,
  } = props

  const [height, setHeight] = useState<number | undefined>(undefined)

  const { t } = useTranslation()

  return (
    <Container className={className}>
      <Label disabled={disabled}>
        {label}
        {!required && !hideOptional && <LabelOptional>{` (${t('components_TextArea_label_optional')})`}</LabelOptional>}
      </Label>
      <TextInputContainer error={error} disabled={disabled}>
        <TextInput
          style={{ height }}
          disabled={disabled}
          required={required}
          placeholder={placeholder}
          value={value}
          onChange={(e) => (!disabled && onChange ? onChange(e.target.value, e.target) : undefined)}
          onInput={(e) => {
            setHeight(e.currentTarget.scrollHeight)
          }}
          onPaste={(e) => {
            setHeight(e.currentTarget.scrollHeight)
          }}
          autoFocus={autoFocus}
        />
      </TextInputContainer>
      <LabelHint error={error}>{hint}</LabelHint>
    </Container>
  )
}
